import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndexResponseType,
  ApiPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndexRequestType,
} from "~/domains";

type RequestDataType = {
  companyId: string;
  params?: ApiPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndexRequestType;
};

const request = async ({
  params,
  companyId,
}: RequestDataType): Promise<ApiPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndexResponseType>(
      `/api/partner_consoles/companies/${companyId}/analytics/feedback_analysis`,
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndexRequestType;
  companyId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndex = ({
  params,
  companyId,
  config = {},
}: PropsType): UseQueryResult<ApiPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisPartnerConsolesCompaniesAnalyticsFeedbackAnalysisIndex",
      companyId,
      params,
    ],
    queryFn: () => request({ companyId, params }),
  });
};
